import { Component, OnInit, ViewChild, ElementRef, PLATFORM_ID, DOCUMENT, ChangeDetectionStrategy, inject, input, ViewContainerRef, ComponentRef, NgZone, ChangeDetectorRef, effect } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Platform, PopoverController } from '@ionic/angular';
import { Subscription } from 'rxjs';
// import { TopSearchesComponent } from '../top-searches/top-searches.component';
import { UtilsService } from 'src/app/services/utils/utils.service';
// import { StorageService } from 'src/app/services/storage/storage.service';
import { SearchComponent } from '../search/search.component';
import { QuickComponentsService } from 'src/app/services/quick-components/quick-components.service';
import { EventService } from 'src/app/services/event/event.service';
import { SessionService } from 'src/app/services/session/session.service';
import { UiFeedbackService } from '../../services/ui-feedback/ui-feedback.service';
import { FEED_FRESCO_MS, NotificacionesCampanaService } from '../../services/notificaciones-campana/notificaciones-campana.service';

/**
 * Popover visible at once (owner, 02/11/2026: «tardan mucho en abrir... no es fluido").
 * `animated: false` only sets the parent animation to 0 ms; Ionic's md enter animation gives
 * its children their own durations (wrapper opacity 150 ms, content scale), so the panel
 * still faded in over ~150 ms (measured on core-p2). Inline `!important` beats Web Animations
 * in the cascade, so the final state is pinned here before `present()`.
 */
export function sinFundido(po: HTMLElement) {
  const fijar = (el: HTMLElement | null | undefined, props: Record<string, string>) => {
    for (const [prop, valor] of Object.entries(props)) el?.style.setProperty(prop, valor, 'important');
  };
  fijar(po.shadowRoot?.querySelector<HTMLElement>('.popover-wrapper'), { opacity: '1' });
  fijar(po.shadowRoot?.querySelector<HTMLElement>('.popover-content'), { opacity: '1', transform: 'none' });
  fijar(po.querySelector?.<HTMLElement>('.popover-viewport'), { opacity: '1' });
}

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false,
    // La cabecera no estaba dentro de ninguna región: axe daba `region` en TODAS las
    // rutas por el logo y el logo móvil (medido el 17/09 contra producción). El papel va
    // en el anfitrión y no en la plantilla para no tocar `.container > .toolbar`, de lo
    // que cuelga toda su hoja de estilos.
    // La cabecera es el <header> de la plantilla, no el anfitrion: si el rol se queda aqui
    // ademas de la etiqueta, salen DOS banner y axe marca landmark-unique.
    // `cabecera26`: cabecera de escritorio de tres filas (diseño V26, S5); en móvil no se pone.
    host: {
      '(window:resize)': 'resize()',
      '[class.cabecera26]': '!isMobile',
      // `cabecera-movil`: barra clara con logo y buscador (odd/tasks/movil-cabecera-tarjeta-cuenta.md, S2/S5).
      '[class.cabecera-movil]': 'isMobile',
      // Con el menú móvil a pantalla completa la barra tiene que quedar por encima de la barra
      // inferior (z 900) y del aviso de cookies (999): el panel vive dentro de su contexto (z 10).
      '[class.menu-movil-abierto]': 'opened && isMobile',
      '[style.z-index]': 'opened && isMobile ? 1000 : null'
    }
})
export class ToolbarComponent implements OnInit {
  private popover = inject(PopoverController);
  private ionPlatform = inject(Platform);
  private zona = inject(NgZone);
  private cd = inject(ChangeDetectorRef);
  private utils = inject(UtilsService);
  private ui = inject(UiFeedbackService);
  private session = inject(SessionService);
  private quick = inject(QuickComponentsService);
  private event = inject(EventService);
  private platformId = inject<Object>(PLATFORM_ID);
  private document = inject<Document>(DOCUMENT);
  private campana = inject(NotificacionesCampanaService);

  // @Output() getStoresCategories = new EventEmitter();
  // @Output() setMobileMenuIsOpen = new EventEmitter<boolean>();

  // @Input()
  // isAdmin: boolean;

  // @Input()
  // adminPage: string;

  readonly url = input<string>(undefined);

  readonly categories = input<any[]>(undefined);

  readonly bigCategories = input<any[]>(undefined);

  readonly stores = input<any[]>(undefined);

  @ViewChild('openMenuButton')openMenuButton: ElementRef;

  // @Input()
  // storesCategoriesLoaded: any;

  // @Input() mobileMenuIsOpen = false;

  // recentSearches: any[] = [];

  subscriptionIconEvent: Subscription;
  currentIconKmh = 'heart';
  /** Unread items of the bell (odd/tasks/notificaciones-actividad.md, N1); 0 hides the badge. */
  get notificationCount() { return this.campana.unread(); }
  /** Badge text: capped at «9+». */
  get notificationBadge() { const n = this.notificationCount; return n > 9 ? '9+' : String(n); }
  remove_banner = false;
  searchIsOpen = false;
  eventButtons: any;
  /** Breakpoint compartido (UtilsService): antes era un campo propio con su checkMobile(). */
  get isMobile() { return this.utils.isMobileSignal(); }
  opened = false;
  /**
   * La señal de SessionService, tal cual. Antes era un campo plano que un `checkUser()`
   * rellenaba en `ngOnInit` y en cada `userEvent$`; el valor era el mismo y la suscripción
   * sólo servía para volver a leerlo.
   */
  readonly user = this.session.user;
  po: any;

  async ngOnInit() {
    // console.log(this.isMobile);

    if (isPlatformBrowser(this.platformId)) {
      // this.document.body.classList.add('banner_top_active');
      // this.getRecientes();
      this.montarMenu();
      this.precargarAlertasEnReposo();
    }

    this.currentIconKmh = await this.event.getCurrentIcon();
    this.subscriptionIconEvent =  this.event.iconEvent$.subscribe((data: any) => {
      this.currentIconKmh = data;
    });
  }

  ngOnDestroy() {
    this.subscriptionIconEvent?.unsubscribe();
  }

  // async search(event) {
  //   try {
  //     if (!event.detail.value) {
  //     } else {
  //       const response = await this.session.mc.getTags({
  //         offset: 0,
  //         limit: 10,
  //         show_image: 1,
  //         // limit: this.limit,
  //         search: event.detail.value,
  //         order_by: 'popularity'
  //       });
  //       if (response && response.ok) {
  //         if (response.tags && response.tags.results && response.tags.results.length > 0) {
  //           this.po.dismiss();
  //           this.openTopSearchPopover(event, response.tags.results);
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     await this.ui.showToast('Error al hacer la búsqueda');
  //   }
  // }

  // Los paneles que abre la barra se cargan al pulsar, no al arrancar. Importados de
  // forma estática viajaban en main.js (unos 110 KB sin comprimir entre los seis) aunque
  // el visitante anónimo no pueda abrir ninguno: ShellModule deja de ser el cascarón que
  // dice ser. Con `import()` caen en el chunk compartido de ComponentModule, que la primera
  // página lazy ya ha descargado, así que al pulsar no se espera nada (lote 21).
  async openUserToolPanel(ev: any) {
    const { UserToolPanelComponent } = await import('../user-tool-panel/user-tool-panel.component');
    const popover = await this.popover.create({
      component: UserToolPanelComponent,
      cssClass: 'user_menu no_bg ng_bs border_radius_0 panel_popover toolbar_popover',
      event: ev,
      alignment: 'end',
      componentProps: {
        currentIconKmh: this.currentIconKmh,
        isMobile: this.isMobile
      }
    });

    popover.present();
  }

  // async openMobileMenu() {
  //   await this.menu.open('menu');
  //   let isOpen = await this.menu.isOpen('menu');
  //   this.setMobileMenuIsOpen.emit(isOpen)
  // }

  // async closeMobileMenu() {
  //   await this.menu.close('menu');
  //   let isOpen = await this.menu.isOpen('menu');
  //   this.setMobileMenuIsOpen.emit(isOpen);
  // }

  openMenuButtons(event: any) {
    this.eventButtons = event;
  }

  /**
   * MENÚ MÓVIL EN LÍNEA.
   *
   * Por qué existe: medido el 25/09 (moto g, 4x CPU), abrirlo con `ion-popover` costaba 79 ms
   * con un fotograma de 59. Migrar sus iconos a `app-icon` lo dejó en 62/38-41, y el resto ya
   * no es código nuestro: es la maquinaria del overlay de Ionic. La referencia de lo fluido,
   * medida con un panel que YA está en el DOM y se muestra con CSS, es 17 ms y cero fotogramas
   * largos.
   *
   * Cómo, sin pagarlo en el bundle inicial: el componente es AUTÓNOMO y se crea con
   * `createComponent` tras el mismo `import()` dinámico de siempre, en el primer hueco de
   * inactividad. O sea que sigue fuera de `main.js` —que es para lo que existe ShellModule— y
   * aun así está en el DOM antes de que el usuario pulse. Pintarlo en la plantilla de la barra
   * NO vale: exigiría tenerlo en el ámbito de ShellModule y eso lo metería en el bundle inicial
   * (NG8001 si no se hace; medido: el arranque ya evalúa 4.780 kB con un 38 % de uso).
   *
   * Escritorio sigue con el popover: otro botón, el menú se posiciona contra él y no hay
   * medida que justifique tocarlo.
   */
  @ViewChild('anclaMenu', { read: ViewContainerRef }) anclaMenu?: ViewContainerRef;
  menuMontado = false;
  private refMenu?: ComponentRef<any>;

  private montarMenu() {
    if (this.refMenu || !isPlatformBrowser(this.platformId) || !this.isMobile) return;
    this.zona.runOutsideAngular(() => {
      const montar = async () => {
        const { MenuPrincipalComponent } = await import('../menu-principal/menu-principal.component');
        this.zona.run(() => this.crearMenu(MenuPrincipalComponent));
      };
      const w = window as any;
      if (typeof w.requestIdleCallback === 'function') w.requestIdleCallback(() => void montar(), { timeout: 4000 });
      else setTimeout(() => void montar(), 2500);
    });
  }

  private crearMenu(MenuPrincipalComponent: any) {
    if (this.refMenu || !this.anclaMenu) return;
    const ref = this.anclaMenu.createComponent(MenuPrincipalComponent) as ComponentRef<any>;
    // `mobile`: cabecera con el cierre y sin el bloque «Inicio / Cupones / Chat».
    ref.setInput('mobile', true);
    ref.setInput('categories', this.categories());
    ref.setInput('bigCategories', this.bigCategories());
    ref.setInput('stores', this.stores());
    ref.setInput('url', this.url());
    ref.instance.cerrar.subscribe(() => this.cerrarMenu());
    this.refMenu = ref;
    this.menuMontado = true;
    this.buscadorMontado = true;
    // Atrás del sistema (app de Android): con el menú abierto, lo cierra en vez de salir.
    this.ionPlatform.backButton.subscribeWithPriority(110, (siguiente) => {
      if (this.opened) this.zona.run(() => this.cerrarMenu());
      else siguiente();
    });
    ref.changeDetectorRef.detectChanges();
    this.cd.markForCheck();
  }

  /** Lleva el foco al cierre al abrir: con el panel a pantalla completa, lo de detrás no se ve. */
  private enfocarCierre() {
    const raiz = this.refMenu?.location.nativeElement as HTMLElement | undefined;
    if (!raiz) return;
    requestAnimationFrame(() => raiz.querySelector<HTMLElement>('.cerrar')?.focus({ preventScroll: true }));
  }

  /**
   * Igual que el menú, pero más simple: `SearchComponent` ya está en ShellModule (lo usa la
   * barra en escritorio), así que no hace falta crearlo a mano, basta un `@if`. Lo que NO se
   * puede es reutilizar la instancia de `.center`: con `[mobile]="true"` su plantilla pinta
   * `app-top-searches` siempre (ver su línea 27), y eso serían nodos en todas las páginas.
   * Montarlo tras el idle deja el SSR intacto.
   */
  buscadorMontado = false;

  cerrarBuscador() {
    if (!this.searchIsOpen) return;
    this.searchIsOpen = false;
    this.cd.markForCheck();
  }

  cerrarMenu() {
    if (!this.opened) return;
    this.opened = false;
    this.cd.markForCheck();
  }

  async openMenuPopover(event) {
    // Camino rápido: el panel ya está en el DOM, abrir es cambiar una clase.
    // Pulsado antes del hueco de inactividad: se monta ya, y nada de popover en el móvil.
    if (this.isMobile && !this.menuMontado && isPlatformBrowser(this.platformId)) {
      const { MenuPrincipalComponent } = await import('../menu-principal/menu-principal.component');
      this.crearMenu(MenuPrincipalComponent);
      this.opened = false;
    }

    if (this.isMobile && this.menuMontado) {
      this.opened = !this.opened;
      // Las entradas pueden haber llegado después de montarlo (categorías y tiendas vienen de
      // la API), así que se refrescan al abrir: es una asignación, no una construcción.
      if (this.opened && this.refMenu) {
        this.refMenu.setInput('categories', this.categories());
        this.refMenu.setInput('bigCategories', this.bigCategories());
        this.refMenu.setInput('stores', this.stores());
        this.refMenu.setInput('url', this.url());
        this.enfocarCierre();
      }
      this.cd.markForCheck();
      return;
    }

    // if (this.platform.width() < 767) {
    //   this.openMobileMenu();
    // } else {
      // await this.storesCategoriesLoaded

      const { MenuPrincipalComponent } = await import('../menu-principal/menu-principal.component');
      const pop = await this.popover.create({
        component: MenuPrincipalComponent,
        cssClass: 'menu-pr no_bg ng_bs border_radius_0',
        event,
        showBackdrop: false,
        animated: false,
        componentProps: {
          bigCategories: this.bigCategories(),
          categories: this.categories(),
          stores: this.stores(),
          url: this.url()
        },
        side: 'bottom',
        alignment: 'end'
      });

      this.opened = true;
      pop.present();

      await pop.onWillDismiss();
      this.opened = false;
    // }

  }

  async openMessagePopover() {
    this.openMenuButton.nativeElement.click();

    const { UserHeaderMessagesComponent } = await import('../user-header-messages/user-header-messages.component');
    await this.abrirPanelCabecera(UserHeaderMessagesComponent, 'message-pr');
  }

  /**
   * Los tres desplegables de la cuenta (Alertas, Mensajes, Guardados) se abren igual (dueño,
   * 02/11/2026: «en un menú que se abriera más o menos igual»): mismas opciones, misma clase
   * de carcasa `panel_cabecera` y mismas medidas. Antes Guardados iba translúcido, con
   * animación y desplazado 51 px por `ion-popover.saved-deals-pr` de global.scss; las
   * variables en línea ganan a esa regla, así que las medidas se fijan aquí para los tres.
   * La clase propia de cada uno (`alert-pr`...) se queda: global.scss le quita la barra
   * horizontal al contenido.
   */
  private async abrirPanelCabecera(component: any, clase: string) {
    const po = await this.popover.create({
      component,
      cssClass: `${clase} panel_cabecera no_bg ng_bs border_radius_0 panel_popover toolbar_popover`,
      event: this.eventButtons,
      showBackdrop: false,
      side: 'bottom',
      alignment: 'end',
      animated: false
    });
    const medidas: Record<string, string> = { '--width': '420px', '--min-width': '0', '--max-width': '94vw', '--offset-x': '0px', '--offset-y': '0px' };
    for (const [variable, valor] of Object.entries(medidas)) po.style?.setProperty(variable, valor);
    sinFundido(po);
    po.present();
    return po;
  }

  /**
   * Bell panel ready before the click (owner, 02/11/2026: «tarda mucho en salir»). Measured
   * on core-p2 (4x CPU, slow 4G): the click downloaded the panel chunk (~0.5 s) and only then
   * asked `GET /socialfeed`, so rows painted ~1.1 s after the click. Now the chunk loads at
   * idle, the feed is warmed on hover/focus and kept by the bell service, and the popover
   * opens without its animation.
   */
  private panelAlertas?: Promise<typeof import('../user-alert-panel/user-alert-panel.component')>;

  private cargarPanelAlertas() {
    return this.panelAlertas ??= import('../user-alert-panel/user-alert-panel.component')
      .then(modulo => { this.calentarPopover(modulo.UserAlertPanelComponent); return modulo; })
      .catch(error => { this.panelAlertas = undefined; throw error; });
  }

  /**
   * Ionic lazy-loads its own `ion-popover` and `ion-backdrop` on the first popover of the
   * page: two more chunks, ~0.4 s on slow 4G, AFTER the click. Creating (never presenting)
   * one popover loads and renders them; it is removed as soon as it is ready.
   */
  private calentarPopover(component: any) {
    this.popover.create({ component, animated: false, showBackdrop: false })
      .then(po => po.remove())
      .catch(() => undefined);
  }

  private precargarAlertasEnReposo() {
    this.zona.runOutsideAngular(() => {
      const precargar = () => { if (this.user()) this.cargarPanelAlertas().catch(() => undefined); };
      const w = window as any;
      if (typeof w.requestIdleCallback === 'function') w.requestIdleCallback(precargar, { timeout: 5000 });
      else setTimeout(precargar, 3000);
    });
  }

  /** Bell hovered or focused: chunk and feed on their way before the click lands. */
  precargarAlertas() {
    if (!this.user()) return;
    this.cargarPanelAlertas().catch(() => undefined);
    this.campana.precargarFeed();
  }

  async openAlertPopover() {
    this.openMenuButton.nativeElement.click();
    // In parallel with the chunk: the panel reuses this same request (shared in the service).
    void this.campana.cargarFeed(FEED_FRESCO_MS);

    const { UserAlertPanelComponent } = await this.cargarPanelAlertas();
    await this.abrirPanelCabecera(UserAlertPanelComponent, 'alert-pr');
  }

  // async openTopSearchPopover(ev) {
  //   this.po = await this.popover.create({
  //     component: TopSearchesComponent,
  //     componentProps: {
  //       recentSearches: this.recentSearches,
  //       // suggestions
  //     },
  //     cssClass: 'top-searches no_bg ng_bs border_radius_0',
  //     event: ev,
  //     animated: false,
  //     showBackdrop: false,
  //     keyboardClose: false,
  //     side: 'bottom',
  //     alignment: 'end'
  //   });
  //   this.po.present();
  // }

  // async getStores() {
  //   const params = {
  //     // offset: 0,
  //     limit: 8,
  //     type: 'store',
  //     order_by: 'popularity'
  //   };
  //   // const resp: any = await this.rest.getStores(params);
  //   const resp = await this.rest.getApiData(params, 'tags', 'stores_toolbar');
  //   if (resp && resp.ok) {
  //     this.stores = resp.tags.results;
  //   }
  // }

  // async getCategories() {
  //   const params = {
  //     limit: 16,
  //     type: 'category'
  //   };
  //   // const resp: any = await this.rest.getCategories(params);
  //   const resp = await this.rest.getApiData(params, 'tags', 'categories_toolbar');
  //   if (resp && resp.ok) {
  //     this.categories = resp.tags.results;
  //   }
  // }

  // async saveInRecientes(tag: any) {
  //   try {
  //     if (this.recentSearches && this.recentSearches.length > 0) {
  //       // To avoid duplicates
  //       const elems = this.recentSearches.filter(e => e.name === tag.name);
  //       if ((!elems || elems.length === 0) && (tag.name && tag.name !== '')) {
  //         this.recentSearches.push({ name: tag.name, image: tag.image });
  //         this.recentSearches = this.recentSearches.filter(elem => elem.name);
  //         if (this.recentSearches.length > 5) {
  //           this.recentSearches = this.recentSearches.slice(1);
  //         }
  //         const newSearches = JSON.stringify(this.recentSearches);
  //         await this.storage.setItem('recientes', newSearches);
  //       }
  //     } else {
  //       await this.storage.setItem('recientes', JSON.stringify([{ name: tag.name, image: tag.image }]));
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  // searchTag(tag: any) {
  //   try {
  //     this.saveInRecientes(tag);
  //     this.po.dismiss();
  //     if (tag.id) {
  //       this.nav.navigateForward('/' + tag.slug);
  //     } else {
  //       this.nav.navigateForward('/results', { queryParams: { search: tag.name } });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  // async getRecientes() {
  //   try {
  //     const recientes = await this.storage.getItem('recientes');
  //     // const recientes = await Storage.get({ key: 'recientes'});
  //     if (recientes) {
  //       this.recentSearches = JSON.parse(recientes);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  async openSearch(ev: Event) {
    // Camino rápido: el panel ya está en el DOM, abrir es cambiar una clase.
    if (this.isMobile && this.buscadorMontado) {
      this.searchIsOpen = !this.searchIsOpen;
      this.cd.markForCheck();
      return;
    }

    this.searchIsOpen = true;

    const popover = await this.popover.create({
      component: SearchComponent,
      componentProps: {
        mobile: true
      },
      event: ev,
      cssClass: 'searchComponent',
    });

    await popover.present();
    await popover.onDidDismiss();

    this.searchIsOpen = false;
  }

  async uploadPopover(ev: any) {
    const { ShareCholloPannelComponent } = await import('../share-chollo-pannel/share-chollo-pannel.component');
    const popover = await this.popover.create({
      component: ShareCholloPannelComponent,
      cssClass: 'ShareCholloPannelComponent no_bg ng_bs border_radius_0 panel_popover toolbar_popover',
      event: ev,
      translucent: true,
      componentProps: {
        url: this.url()
      },
    });

    popover.present();
  }

  async openSavedDealsPopover() {
    this.openMenuButton.nativeElement.click();

    const { UserHeaderSavedDealsComponent } = await import('../user-header-saved-deals/user-header-saved-deals.component');
    await this.abrirPanelCabecera(UserHeaderSavedDealsComponent, 'saved-deals-pr');
  }

  closeBanner() {
    this.remove_banner = true;
    this.document.body.classList.add('banner_top_disabled');
  }

  resize() {
    this.utils.refreshBreakpoint();
  }

  async openAuthModal(type = 'login') {
    // El re-encadenado (login -> register -> password) lo hace ya openLoginBox: aquí
    // `result` era siempre undefined porque ese método no devuelve nada.
    await this.quick.openLoginBox(type);
  }

}
